<template>
  <div class="display_document">
    <div class="pdf_file">
      <iframe :src="url" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>
<script>
const map = {
  REDUCED_POLICY: "优惠政策",
  LAW_POLICY: "法律法规",
  DEPARTMEN_POLICY: "部门规章",
  SELF_POLICY: "自律规则",
};
export default {
  props: ["url"],
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>
<style scoped>
.container {
  position: relative;
  overflow: hidden;
}
.display_document {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}
.pdf_file {
  width: 100%;
  height: 100%;
  background: #fff;
}
embed {
  width: 100% !important;
  height: 100% !important;
}
.display_document >>> .el-breadcrumb {
  padding-left: 20px !important;
}
</style>
